import React from "react";
import { FaPhoneAlt, FaEnvelope, FaGlobe } from "react-icons/fa";
import images from "../../Data/images";

const Emergences = () => {
  return (
    <div className="w-full text-gray-800">

      {/* Hero Section */}
      <div className="bg-[#c4122f] text-white py-16 px-6 md:px-20">
        <h1 className="text-4xl font-bold mb-4">
          Emergency Security Coverage
        </h1>
        <p className="text-lg max-w-xl">
          Rapid Security Response When You Need It Most
        </p>
      </div>

      {/* Breadcrumb and Contact */}
      <div className="flex justify-between items-center py-4 px-6 md:px-20 border-b border-gray-200 bg-gray-50">
        <span className="text-sm text-gray-500 tracking-wide">
          HOME / EMERGENCY SECURITY
        </span>

        <span className="flex items-center gap-2 text-sm text-gray-700">
          <FaPhoneAlt className="text-[#c4122f]" />
          416-477-7692
        </span>
      </div>

      {/* Intro Section */}
      <section className="py-16 px-6 md:px-20 gap-12 items-center">

        <div className="space-y-6">
          <h2 className="text-3xl font-semibold text-[#c4122f]">
            Rapid Security Response
          </h2>

          <p>
            Unexpected situations can require immediate security coverage.
            Whether responding to a system failure, a security incident, or
            a sudden staffing gap, Argus Security International provides
            rapid-response security services designed to protect your
            property and restore control quickly.
          </p>

          <p>
            Our team is prepared to deploy trained security personnel on
            short notice, helping clients maintain safety, protect assets,
            and respond effectively to urgent security needs.
          </p>
        </div>
      </section>

      {/* Emergency Situations */}
      <section className="py-12 px-6 md:px-20 bg-gray-50">
        <h2 className="text-3xl font-semibold text-[#c4122f] mb-6">
          When Emergency Security Is Needed
        </h2>

        <p className="mb-6">
          Emergency security coverage may be required in a variety of situations including:
        </p>

        <ul className="grid md:grid-cols-2 gap-3 list-disc list-inside text-gray-700">
          <li>Fire alarm system failures</li>
          <li>Sprinkler system shutdowns requiring fire watch</li>
          <li>Break-ins or vandalism incidents</li>
          <li>Security guard no-show situations</li>
          <li>Construction site theft concerns</li>
          <li>Vacant property protection</li>
          <li>Alarm activations requiring investigation</li>
          <li>Temporary security for special events</li>
        </ul>

        <p className="mt-6">
          Argus can quickly mobilize security personnel to monitor the
          property, maintain safety, and prevent further incidents.
        </p>
      </section>

      {/* Emergency Services */}
      <section className="py-16 px-6 md:px-20">
        <h2 className="text-3xl font-semibold text-[#c4122f] mb-8">
          Rapid Deployment of Security Personnel
        </h2>

        <div className="grid md:grid-cols-2 gap-8">

          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="font-semibold text-lg mb-2">
              Emergency Security Guards
            </h3>
            <p>
              Immediate deployment of trained security officers to monitor
              and protect the property.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="font-semibold text-lg mb-2">
              Fire Watch Security
            </h3>
            <p>
              Continuous monitoring when fire protection systems are
              temporarily out of service.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="font-semibold text-lg mb-2">
              Mobile Patrol Response
            </h3>
            <p>
              Rapid patrol services to inspect properties and respond to
              alarm activations or security concerns.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl shadow">
            <h3 className="font-semibold text-lg mb-2">
              Temporary Security Coverage
            </h3>
            <p>
              Short-term security personnel to cover staffing gaps or urgent
              protection needs.
            </p>
          </div>

        </div>
      </section>

      {/* 24/7 Support */}
      <section className="py-12 px-6 md:px-20 bg-gray-50">

        <h2 className="text-3xl font-semibold text-[#c4122f] mb-4">
          24/7 Security Support
        </h2>

        <p className="max-w-3xl">
          Security incidents do not follow a schedule. Argus Security
          International offers 24/7 security coverage and support, ensuring
          clients can access professional security services whenever they
          are needed.
        </p>

        <p className="max-w-3xl mt-4">
          Our team works quickly to assess the situation and deploy
          appropriate security personnel to protect your property.
        </p>

      </section>

      {/* Why Choose Argus */}
      <section className="py-16 px-6 md:px-20">

        <h2 className="text-3xl font-semibold text-[#c4122f] mb-6">
          Why Clients Call Argus for Emergency Security
        </h2>

        <ul className="space-y-3 text-gray-700">
          <li>✔ Rapid response and deployment</li>
          <li>✔ Professional security personnel</li>
          <li>✔ Flexible short-term or temporary coverage</li>
          <li>✔ Reliable monitoring during critical situations</li>
          <li>✔ Protection of property, assets, and occupants</li>
        </ul>

      </section>

      {/* Emergency Contact */}
      <section className="py-16 px-6 md:px-20 bg-[#c4122f] text-white text-center">

        <h2 className="text-3xl font-semibold mb-6">
          Immediate Security Support
        </h2>

        <p className="max-w-3xl mx-auto mb-6">
          Argus Security International provides fast, reliable emergency
          security coverage when urgent situations arise.
        </p>

        <p className="text-xl font-semibold mb-6">
          📞 Emergency Security Services: 416-477-7692 x622
        </p>

        <div className="flex flex-col md:flex-row justify-center gap-6 items-center text-lg">

          <span className="flex items-center gap-2">
            <FaEnvelope /> info@argussecurity.ca
          </span>

          <span className="flex items-center gap-2">
            <FaGlobe /> www.argussecurity.ca
          </span>

        </div>

      </section>

    </div>
  );
};

export default Emergences;